/** The scroll box an element lives in, or null when nothing scrolls above it. */
export function scrollParent(element: HTMLElement): HTMLElement | null {
	// The proposal rail scrolls on a plain overflow-y-auto div, so matching the
	// .scroll-container class alone left every card in it unreachable.
	let node = element.parentElement
	while (node) {
		const overflowY = getComputedStyle(node).overflowY
		if (overflowY === "auto" || overflowY === "scroll") return node
		node = node.parentElement
	}
	return element.closest<HTMLElement>(".scroll-container")
}

/** How far below the top of its scroll box's content an element starts. */
export function offsetWithinScrollParent(
	element: HTMLElement,
	scroller: HTMLElement,
): number {
	return (
		element.getBoundingClientRect().top -
		scroller.getBoundingClientRect().top +
		scroller.scrollTop
	)
}
